module.exports = __webpack_public_path__ + "img/stamp2.457dded1.jpg";